import * as Yup from "yup";

export const checkoutvalidation2 = Yup.object({
  first_name2: Yup.string()
    .label("First Name")
    .min(2)
    .max(19)
    .required("Please Enter First Name"),
  last_name2: Yup.string()
    .label("Last Name")
    .min(2)
    .max(19)
    .required("Please Enter Last Name"),
    address_type: Yup.string()
    .label("Address Type")
    .required("Please Enter Address Type"),
  email2: Yup.string().email().label("Email")
    .required("Please Enter Email"),
  address12: Yup.string()
  .label("Address 1")
    .min(2)
    .max(60)
    .required("Please Enter Address1"),
  address22: Yup.string()
  .label("Address 2")
    .min(2)
    .max(60)
    .required("Please Enter Address2"),
  country2: Yup.string()
    .label("Country")
    .required("Country is required"),
  state2: Yup.string()
    .label("State")
    .min(2)
    .required("State is required"),
  city2: Yup.string()
    .label("City")
    .min(2)
    .required("City is required"),
  pincode2: Yup.string()
    .label("PinCode")
    .min(6)
    .max(6)
    .required("Pincode is required"),
    mobile2: Yup.number()
    .label("Mobile No")
    .min(1000000000, "Mobile number must be at least 10 digits")
    .max(9999999999, "Mobile number cannot be more than 10 digits")
    .required("Mobile Number is required"),
});
